import React, { useState } from "react";
import OnBoardingHead from "../../components/onboarding/OnBoardingHead";
import VesselDetailshead from "../../components/VesselDetailscompo/VesselDetailshead";
import CommonHeader from "../../components/HeaderComponent/CommonHeader";



const VesselDetails = ( ) => {



  return (
    <div className="vessel-page-container">
      <CommonHeader
        headerKey="vessel_details_page"
      />

      <VesselDetailshead/>     
    </div>
  );
};

export default VesselDetails;
